import { Navigate } from "react-router-dom";
import { useAuthContext } from "context/auth-context";

const ProtectedRoute = ({ children }) => {
    const { authenticated, isAuthReady } = useAuthContext();

    if (!isAuthReady) return <div>Loading...</div>;

    return authenticated ? children : <Navigate to="/sign-in" />;
};

export default ProtectedRoute;
